import {createSlice} from '@reduxjs/toolkit';
import {
  authenticate,
  getTokenFromStorage,
  login,
} from './../actions/AuthActions';

const AuthSlice = createSlice({
  name: 'auth',
  initialState: {
    userId: null,
    username: '',
    roleName: '',
    email: '',
    token: getTokenFromStorage(),
    statusCode: 200,
    status: 'idle',
    error: '',
    loading: false,
  },

  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(login.fulfilled, (state, action) => {
        state.status = 'idle';
        const userData = action.payload.result;
        state.userId = userData.accountId; // 原 userId
        state.username = userData.username;
        state.roleName = userData.roleName;
        state.email = userData.email;
        state.token = userData.token;
      })
      .addCase(login.rejected, (state, action) => {
        state.statusCode = action.payload.code;
        state.status = 'rejected';
        state.error = action.payload.message;
      })

      .addCase(authenticate.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(authenticate.fulfilled, (state, action) => {
        state.status = 'idle';
        const userData = action.payload.result;
        state.userId = userData.accountId;
        state.username = userData.username;
        state.roleName = userData.roleName;
        state.email = userData.email;
        state.token = userData.token;
      })
      .addCase(authenticate.rejected, (state, action) => {
        state.statusCode = action?.payload?.code;
        state.status = 'rejected';
        state.error = action?.payload?.message;
      });
  },
});

export const {setToken} = AuthSlice.actions;

export default AuthSlice.reducer;
